import { Grid } from '@material-ui/core';
import {
  EntityUserProfileCard,
  EntityOwnershipCard,
} from '@backstage/plugin-org';
import { EntityLayout } from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { EntityWarningContent } from './modules/EntityWarningContent';
import { EntitySpecreqSkillsCard } from '@infra360/plugin-specreq';

function Overview() {
  return (
    <Grid container spacing={3} alignItems="stretch">
      <EntityWarningContent />
      <Grid item xs={12} md={8}>
        <EntityOwnershipCard />
      </Grid>
      <Grid item xs={12} md={4}>
        <EntityUserProfileCard />
      </Grid>
      <Grid item xs={12} md={8} />
      <Grid item xs={12} md={4}>
        <EntitySpecreqSkillsCard />
      </Grid>
    </Grid>
  );
}

// Wrapped in a local component so collectEntityPageContents assigns it to
// orphanRoutesPlugin (no core.plugin) rather than the catalog-graph alpha
// plugin instance, which would be deduplicated away before the tab registers.
function RelationsTab() {
  return <EntityCatalogGraphCard height={400} />;
}

export const userPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Overview />
    </EntityLayout.Route>

    <EntityLayout.Route path="/relations" title="Relations">
      <RelationsTab />
    </EntityLayout.Route>
  </EntityLayout>
);
